// extracted by mini-css-extract-plugin
export default {"card-area":"CardArea_card-area__ClzrE","card-count":"CardArea_card-count__KiC0h","verbear-image":"CardArea_verbear-image__zxkel"};